import { render, staticRenderFns } from "./add-discipline.vue?vue&type=template&id=55879c50&scoped=true"
import script from "./add-discipline.vue?vue&type=script&lang=js"
export * from "./add-discipline.vue?vue&type=script&lang=js"
import style0 from "./add-discipline.vue?vue&type=style&index=0&id=55879c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55879c50",
  null
  
)

export default component.exports